import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define the initial state using that type
interface Invoice {
  invoice_id: string;
  invoice_ref_number: string;
}

const initialState: {value: Invoice[]} = {value: []}
export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setInvoice: (state, action: PayloadAction<Invoice[]>) => {
      state.value = action.payload;
    },

    addInvoice: (state, action: PayloadAction<Invoice>) => {
      state.value = [...state.value, action.payload]
    },
    addInvoiceBatch: (state, action: PayloadAction<Invoice[]>) => {
      state.value = [...state.value, ...action.payload]; // Add Multiple Invoices
    },
    clearInvoices: () => initialState,
  },
});

export const { setInvoice, addInvoice, addInvoiceBatch, clearInvoices } = invoiceSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectInvoices = (state: RootState) => state.selectInvoice.value;

export default invoiceSlice.reducer;
